// extracted by mini-css-extract-plugin
export var matchField = "matchField-module--matchField--8QEZZ";
export var matchField__fieldSection = "matchField-module--matchField__fieldSection--wiBha";
export var matchField__playerCircle = "matchField-module--matchField__playerCircle--TNMCo";
export var matchField__playerCircleAway = "matchField-module--matchField__playerCircleAway--1ibOQ";
export var matchField__playerCircleHome = "matchField-module--matchField__playerCircleHome--h8SfG";
export var matchField__section = "matchField-module--matchField__section--J1wEb";
export var matchField__team = "matchField-module--matchField__team--7YC6z";
export var matchField__wrapper = "matchField-module--matchField__wrapper--tmaqi";